import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

// ホーム画面へ追加を誘導するポップアップ
// ログイン済みユーザーにのみ表示される（ERBテンプレート側で制御）
// Connects to data-controller="home-screen-guide"
export default class extends Controller {
  static values = {
    guideViewed: Boolean,
    apiEndpoint: String
  }

  static targets = ["modal", "checkbox"]

  connect() {
    if (this.shouldShowModal()) {
      this.showModal()
    }
  }

  shouldShowModal() {
    const isMobile = window.matchMedia('(max-width: 768px)').matches
    return isMobile && !this.guideViewedValue
  }

  showModal() {
    this.modal = Modal.getOrCreateInstance(this.modalTarget)
    this.modal.show()
  }

  async markAsViewed(event) {
    const viewed = event.target.checked

    try {
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
      const response = await fetch(this.apiEndpointValue, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken
        },
        body: JSON.stringify({ home_screen_guide_viewed: viewed })
      })

      if (!response.ok) {
        event.target.checked = !viewed
        console.error('Failed to update home screen guide setting')
      }
    } catch (error) {
      event.target.checked = !viewed
      console.error('Network error:', error)
    }
  }
}
